import { ApiUnavailable } from "@/components/ApiUnavailable"
import { useApiStatus } from "@/context/ApiStatusProvider"
import { useAuth } from "../context/AuthProvider"
import { AppRoutes } from "./app.routes"
import { AuthRoutes } from "./auth.routes"

export default function Routes(){
  const{isAuthenticated} = useAuth()
  const { isApiDown } = useApiStatus()

  if (isApiDown) {
    return <ApiUnavailable />
  }

  return isAuthenticated ? <AppRoutes /> : <AuthRoutes />
}